/* istanbul ignore file */
import React from 'react';

import {IconMinusCircle} from '@veneer/core';

import {useWolfTheme} from '@br/mg-components';

import useStyles from './styles';

const FormError = ({error}: {error?: string}) => {
    const styles = useStyles();
    const theme = useWolfTheme();

    return (
        <>
            {error && (
                <p className={styles.helper}>
                    <span className={`${styles.helperIcon} icon`}>
                        <IconMinusCircle
                            filled
                            customStyle={{color: theme.palette.negative.default}}
                        />
                    </span>
                    <span className={`${styles.helperText} caption text`}>{error}</span>
                </p>
            )}
        </>
    );
};

export default FormError;
